module.exports = __webpack_public_path__ + "img/loader.2f212d1f.gif";